import { useTranslation } from "react-i18next";
import React, { useContext, useEffect, useState } from "react";
import useMmcService from "../../services/MmcService";
import InitContext from "../pages/InitContext";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import Icd10Tree from "../disease/Icd10Tree";
import {Consts} from "../pages/consts";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

const Diseases = ({ patientDiseases, onSetPatientDiseases, diseasesToShow, setPatientsDiseasesInDb }) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);
  const { loading, error, clearError, getDiseasesJson, deleteDbDisease } = useMmcService();
  const [icd10Data, setIcd10Data] = useState([]);
  const [alreadyAddedError, setAlreadyAddedError] = useState(false);

  useEffect(() => {
    if (context?.token && context?.token !== "") {
      clearError();

      getDiseasesJson(context?.token).then((data) => {
        setIcd10Data(data);
      });
    }
  }, []);

  const handleDeleteDisease = (disease) => {
    if(disease?.id){ // the disease to delete was stored in the DB
      deleteDbDisease(context?.token, disease?.id).then((result) => {
        const newDiseases = diseasesToShow?.filter(d  => d?.id !== result?.id);
        setPatientsDiseasesInDb(newDiseases);
        onSetPatientDiseases([]);
      });
    } else { // the disease to delete is a new one, which is not yet stored in the DB
      const newDiseases = patientDiseases?.filter(d  => d?.icd10 !== disease?.icd10);
      onSetPatientDiseases(newDiseases);
    }
  };

  const errorMessage = error && <ErrorMessage message={t("error_by_retrieving_all_diseases")} />;
  const spinner = loading && <Spinner />;

  const localErrorMessage = alreadyAddedError && (
    <ErrorMessage message="The disease is already selected" />
  );

  return (
    <div>
      {localErrorMessage}
      <div className="w3-row">
        {(context?.role === Consts.HCP_PRESCRIBER || context?.role === Consts.PATIENT) &&
          <div className="w3-col m8 form-content-scroll">
            <div className="w3-container w3-padding">
              <Icd10Tree
                data={icd10Data}
                patientDiseases={patientDiseases}
                onSetPatientDiseases={onSetPatientDiseases}
                closeDialog={() => {}}
                diseasesToShow={diseasesToShow}
                setAlreadyAddedError={(value) => setAlreadyAddedError(value)}
              />
            </div>
          </div>
        }
        {diseasesToShow?.length > 0 && (
          <div className={(context?.role === Consts.HCP_PRESCRIBER || context?.role === Consts.PATIENT)
            ? "w3-col m4 w3-padding-small"
            : "w3-col m12 w3-padding-small"}
          >
            <div style={{ backgroundColor: "#FFFFE0"}}>
              <div className="subtitle" style={{ padding: "12px" }}>
                {(context?.role === Consts.HCP_PRESCRIBER || context?.role === Consts.PATIENT)
                  ? t("selected_diseases")
                  : t("diseases")}
              </div>
              <ul className="diseases-scroll" style={{ listStyleType: Consts.NONE, padding: "12px", alignItems: "left" }}>
                {diseasesToShow?.map((disease, i) => (
                  <li
                    key={`${disease?.icd10}-${i}`}
                    style={{
                      display: "flex",
                      alignItems: "start",
                      gap: "10px",
                      marginBottom: "10px",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div className="mmc-text" style={{ minWidth: "150px",  textAlign: "left", flex: 1, color: disease.id ? "#1565a0" : "#f10909" }}>
                      {disease?.icd10name} ({disease?.icd10})
                    </div>
                    {(context?.role === Consts.HCP_PRESCRIBER || context?.role === Consts.PATIENT) &&
                      <button
                        type="button"
                        onClick={() => handleDeleteDisease(disease)}
                        className="symptom-ui-button symptom-ui-button--icon symptom-ui-button--danger"
                        aria-label={t("delete", { defaultValue: "Delete" })}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    }
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
      {errorMessage}
      {spinner}
    </div>
  );
};

export default Diseases;
